import { useLiveStreamAppContext } from "../ContextStore/Store";
import axios from "axios";

const ExtendTime = () => {
  const {
    apiUrlPost,
    __appConfirmUniqueID,
    __merchantId,
    __userId,
    headers,
    chatThreadClientRef,
    communicationUserId,
    setLoaderAnimation,
    setstrExtendedEndTimeUTC,
    appInsightTrack,
    setErrorMessage
  } = useLiveStreamAppContext();
  
  async function extendTimeFunction(ExtendedAppEndTime, minutes) {
    const callExtendFunction = async () => {
      try {
        await axios.post(
          `${apiUrlPost}extendlivestreamduration`,
          {
            ExtendedDuration: minutes,
            appConfirmUniqueId: __appConfirmUniqueID,
            strExtendedEndTimeUTC: ExtendedAppEndTime,
          },
          { headers }
        );
        chatThreadClientRef.current.sendMessage({
          content: "",
          metadata: {
            senderUserId: communicationUserId.communicationUserId,
            targetUserId: "",
            extendedDate: ExtendedAppEndTime,
            customType: "EXTEND_TIME",
          },
        });

        setstrExtendedEndTimeUTC(ExtendedAppEndTime);
      } catch (error) {
        setLoaderAnimation(false);
        setErrorMessage(error.message);
        console.error("Error posting extend function", error);
        appInsightTrack(__merchantId, __userId, "API Error extendlivestreamduration", "", error);
      }
    };
    await callExtendFunction();
  }

  return { extendTimeFunction }
}

export default ExtendTime